import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CompanyCard = ({ company, onSelect, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, delay: index * 0.1 }}
      whileHover={{ y: -5, scale: 1.02 }}
      onClick={() => onSelect(company)}
      className="bg-card rounded-xl p-6 border border-border shadow-brand hover:shadow-brand-hover transition-brand cursor-pointer group relative overflow-hidden"
    >
      {/* Background accent - Made more visible */}
      <div className="absolute top-0 right-0 w-32 h-32 gradient-brand opacity-15 rounded-full blur-3xl pointer-events-none"></div>
      <div className="relative z-10">
        {/* Company Logo with better visibility and error handling */}
        <div className="flex items-center justify-between mb-4">
          <div className="relative w-20 h-20 rounded-lg flex items-center justify-center bg-white border-2 border-gray-100 p-2">
            <Image 
              src={company?.logo} 
              alt={company?.logoAlt}
              className="w-full h-full object-contain"
              onError={(e) => {
                console.error('Logo failed to load:', company?.logo);
                e.target.src = '/assets/images/no_image.png';
              }}
            />
          </div>
          <div className={`w-12 h-12 rounded-full ${company?.accentColor} bg-opacity-10 flex items-center justify-center group-hover:rotate-12 transition-brand`}>
            <Icon name="ArrowRight" size={24} color={company?.iconColor} />
          </div>
        </div>

        <h3 className="text-2xl font-semibold text-foreground mb-3 group-hover:text-primary transition-brand">
          {company?.name}
        </h3>
        
        <p className="text-muted-foreground text-sm leading-relaxed mb-6 line-clamp-3">
          {company?.description}
        </p>

        <div className="space-y-3 mb-6">
          {company?.highlights?.map((highlight, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className={`w-6 h-6 rounded-full ${company?.accentColor} bg-opacity-20 flex items-center justify-center flex-shrink-0`}>
                <Icon name="Check" size={14} color={company?.iconColor} />
              </div>
              <span className="text-sm text-foreground">{highlight}</span>
            </div>
          ))}
        </div>

        <Button 
          onClick={(e) => {
            e?.stopPropagation();
            onSelect(company);
          }}
          variant="outline" 
          fullWidth 
          className="mt-6 group-hover:bg-primary group-hover:text-primary-foreground group-hover:border-primary"
          iconName="ArrowRight"
          iconPosition="right"
        >
          Select {company?.name?.split(' ')?.[0]}
        </Button>
      </div>
    </motion.div>
  );
};

export default CompanyCard;